<template>
  <div class="api-layer">
    <fieldset>
      <legend>RoomUser</legend>

      <div class="api-box inline"
           :class="{inline: !roomUser.desc}"
      >
        <label class="api-title">list</label>
        roomId:<input type="text" name="roomId" />
        <button @click="getRoomUserList">OK</button>
        <div
            v-if="!!roomUser.desc"
        >
          <pre>userCnt: {{ roomUser.desc.length }}명<br>{{ roomUser.desc }}</pre>
        </div>
      </div>

      <div class="api-box">
        <label class="api-title">leave</label>
        roomId:<input type="text" name="roomId" />
        userId:<input type="text" name="userId" />
        <button @click="leave">OK</button>
      </div>
      <div class="api-box">
        <label class="api-title">leave all</label>
        roomId:<input type="text" name="roomId" />
        <button @click="leaveAll">OK</button>
      </div>

      <div class="api-box">
        <label class="api-title">req reEnter</label>
        roomId:<input type="text" name="roomId" />
        userId:<input type="text" name="userId" />
        <button @click="reqReEnter">OK</button>
      </div>
      <div class="api-box">
        <label class="api-title">req reEnterAll</label>
        roomId:<input type="text" name="roomId" />
        <button @click="reqReEnterAll">OK</button>
      </div>

      <div class="api-box">
          <label class="api-title">gc roomUser</label>
          <input type="number" name="beforeEnterDateMinutes" value="1440" /> 분전 입장자들을
          한번에 <input type="number" name="limit" value="100" /> 번 처리하고
          최대 <input type="number" name="maxLoop" value="1" /> 번 반복한다.
          <button @click="gcRoomUser">OK</button>
          <span class="desc-inline"></span>
      </div>

      <div class="api-box">
          <label class="api-title">roomUser ws session size</label>
          <button @click="wsSessionSize">OK</button>
          <span class="desc-inline"></span>
      </div>
      <div class="api-box">
        <label class="api-title">roomUser ws serverId</label>
          roomId:<input type="text" name="roomId" />
          userId:<input type="text" name="userId" />
        <button @click="roomUserWsServerId">OK</button>
        <span class="desc-inline"></span>
      </div>
    </fieldset>
  </div>
</template>

import {SysAdmin} from "@/core/sysadmin/sysadmin.api";

<script>
import {SysAdmin} from "@/core/sysadmin/sysadmin.api";
import SysAdminBase from "@/components/Sysadmin/SysAdminBase";

export default {
  name: "RoomUser",
  mixins: [SysAdminBase],
  data() {
    return {
      roomUser: {
        desc: null
      },
    }
  },

  methods: {
    async leave(e) {
      const roomId = this.getRoomIdValue(e);
      if(!roomId) return;
      const userId = this.getUserIdValue(e);
      if(!userId) return;

      if(!confirm('go?')) return;

      await SysAdmin.post({
        url: '/room/user/leave',
        params: {roomId, userId}
      })
    },
    async leaveAll(e) {
      const roomId = this.getRoomIdValue(e);
      if(!roomId) return;

      if(!confirm('go?')) return;

      await SysAdmin.post({
        url: '/room/user/leaveAll',
        params: {roomId}
      })
    },

    async reqReEnter(e) {
      const roomId = this.getRoomIdValue(e);
      if(!roomId) return;
      const userId = this.getUserIdValue(e);
      if(!userId) return;

      if(!confirm('go?')) return;

      await SysAdmin.post({
        url: '/room/user/reqReEnter',
        params: {roomId, userId}
      })
    },
    async reqReEnterAll(e) {
      const roomId = this.getRoomIdValue(e);
      if(!roomId) return;

      if(!confirm('go?')) return;

      await SysAdmin.post({
        url: '/room/user/reqReEnterAll',
        params: {roomId}
      })
    },
    async gcRoomUser(e) {
        let beforeEnterDateMinutes = this.getFieldValue(e, '[name="beforeEnterDateMinutes"]')
        beforeEnterDateMinutes = Math.max(beforeEnterDateMinutes, 60*10)

        let limit = this.getFieldValue(e, '[name="limit"]')
        limit = Math.min(limit, 1000);

        let maxLoop = this.getFieldValue(e, '[name="maxLoop"]')
        maxLoop = Math.min(maxLoop, 10);

        if(!confirm('go?')) return;

        const data = await SysAdmin.post({
            url: '/room/user/gc',
            params: {beforeEnterDateMinutes, limit, maxLoop}
        })
        this.writeDescInline(e, `gc count : ${data}`);
    },
    async roomUserWsServerId(e) {
        const roomId = this.getRoomIdValue(e);
        if(!roomId) return;
        const userId = this.getUserIdValue(e);
        if(!userId) return;

        const data = await SysAdmin.get({
            url: '/room/user/wsServerId',
            params: {roomId, userId}
        })
        this.writeDescInline(e, data);
    },
    async wsSessionSize(e) {
        if(!confirm('go?')) return;
        const data = await SysAdmin.get({
            url: '/room/user/wsSessionSize'
        })
        this.writeDescInline(e, data);
    },
    ...(() => {
      const methods = {
        async getRoomUserList(e) {
          const roomId = this.getRoomIdValue(e);
          if(!roomId) return;

          const data = await SysAdmin.get({url: '/room/user/list', params: {
              roomId
          }})
          console.log(data);

          this.roomUser.desc = data;
        },
      }

      return SysAdmin.createDebounceMethods(methods);
    })(),
  },
}
</script>

<style lang="scss" scoped>

</style>